import { helpers } from 'vuelidate/lib/validators';

export const alpha = helpers.regex('alpha', /^[a-zA-Zа-яА-ЯёЁ]*$/);
export const fullName = helpers.regex(
  'fullName',
  /^[a-zA-Zа-яА-ЯёЁ]+(\s[a-zA-Zа-яА-ЯёЁ]*){0,2}$/
);
export const alphaAll = helpers.regex(
  'fullName',
  /^[a-zA-Zа-яА-ЯёЁ]+(\s[a-zA-Zа-яА-ЯёЁ]*)*$/
);
export const alphaAllnum = helpers.regex(
  'fullName',
  /^[0-9a-zA-Zа-яА-ЯёЁ]+(\s[0-9a-zA-Zа-яА-ЯёЁ]*)*$/
);
